import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  penRoot: {
    justifyContent: "center",
    alignItems: "center"
  },

  message: {
    color: theme.palette.text.disabled,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: "center",
    "& svg": {
      fontSize: theme.typography.h1.fontSize
    }
  }
}));
